export default __webpack_public_path__ + "locales/el-GR/ChangeUserStatusDialog.json?hash=f0e3423b915cf00f315ef128ad08ad80";